import CategoryForm from "./CategoryForm"

const EditCategory = () => {
  return (
    <div className='px-4'>
        <CategoryForm />
    </div>
  )
}

export default EditCategory